// eslint-disable-next-line no-use-before-define
import React from 'react'
import { Stack } from '@mui/material'
import MessageDashboardOverview from './MessageDashboardOverviewContent'
import MessageList from './MessageList'
import { useMessagesDashboardViewContext } from '../MessagesDashboardViewContext'

export interface MessageDashboardViewContentProps {
  className?: string
}

function MessageDashboardViewContent({ className }: MessageDashboardViewContentProps) {
  const showOverviewDashboard = true
  const {
    trafficChartVisible,
    toggleTrafficChartVisibility,
    trafficChartFirstTime,
  } = useMessagesDashboardViewContext()

  return (
    <Stack>
      {showOverviewDashboard && (
        <MessageDashboardOverview
          isChartVisible={trafficChartVisible}
          toggleChartVisibility={toggleTrafficChartVisibility}
        />
      )}
      <MessageList
        isSparklineVisible={trafficChartVisible}
        toggleSparklineVisibility={toggleTrafficChartVisibility}
        isFirstTime={trafficChartFirstTime}
      />
    </Stack>
  )
}

export default MessageDashboardViewContent
